import routeHelper from 'src/routes/helper';

export const loggedOutRoutes = [
  routeHelper.resetEmail.href(),
  routeHelper.disambiguation.href(),
  routeHelper.contactSupport.href(),
  routeHelper.accountRecoveryStep.href(2),
  routeHelper.accountRecoveryStep.href(3),
  routeHelper.accountRecovery.href(),
  routeHelper.unableToRecover.href(),
  routeHelper.claimAdditionalAccount.href(),
];
